import { breakpoints } from '@notino/react-styleguide';

import { styled } from '@linaria/react';

export const MainImgWrapper = styled.div`
  order: 2;

  @media (min-width: ${breakpoints.lg}) {
    order: 1;
  }
`;

export const ImageWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const MainImgComponent = styled.img`
  width: 70%;

  @media (min-width: ${breakpoints.sm}) {
    width: 75%;

    flex-grow: 0;
    transition: opacity 0.5s;
  }
`;
